
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#A0A5BA"}},[_c('path',{attrs:{"d":"M6.667 13.665h8.666a1 1 0 000-2H6.667a1 1 0 100 2zm0 4.667h4a1 1 0 100-2h-4a1 1 0 000 2zm0 4.668h3.666a1 1 0 100-2H6.667a1 1 0 000 2zM7 8.332h11.333A.333.333 0 0018.667 8V4a.334.334 0 00-.334-.333H16v-.334A3.345 3.345 0 0011.761.12a3.412 3.412 0 00-2.428 3.33v.215H7A.335.335 0 006.667 4v4A.333.333 0 007 8.332zM12.667 2a1 1 0 110 2 1 1 0 010-2z"}}),_c('path',{attrs:{"d":"M14.613 29.473a.333.333 0 00-.266-.14H3.333a.667.667 0 01-.666-.668V7a.667.667 0 01.666-.667h1A.333.333 0 004.667 6V4a.335.335 0 00-.334-.333H2.667A2.667 2.667 0 000 6.333v23A2.667 2.667 0 002.667 32h13.5a.334.334 0 00.216-.587 10.664 10.664 0 01-1.77-1.94zM24.948 12.8a.337.337 0 00.356-.195.334.334 0 00.03-.14V6.33a2.667 2.667 0 00-2.667-2.667H21a.335.335 0 00-.333.336v2a.333.333 0 00.333.333h1a.667.667 0 01.667.667v5.343a.334.334 0 00.352.333c.105 0 .209-.01.314-.01.541.002 1.081.047 1.615.134zm-1.615 1.867A8.667 8.667 0 1032 23.333a8.677 8.677 0 00-8.667-8.666zm3.334 9.666h-2a.333.333 0 00-.334.334v2a1 1 0 11-2 0v-2a.333.333 0 00-.333-.334h-2a1 1 0 010-2h2a.333.333 0 00.333-.333v-2a1 1 0 112 0v2a.333.333 0 00.334.333h2a1 1 0 010 2z"}})])])
          )
        }
      }
    